import { searchSegments } from "../../convex/model/searchQuery";

export function SearchText({ text, query }: { text: string; query: string }) {
  return <>{searchSegments(text, query).map((part, index) => part.highlighted
    ? <mark key={index} className="rounded-sm bg-amber-200/70 text-inherit">{part.text}</mark>
    : <span key={index}>{part.text}</span>)}</>;
}
